import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import SidebarPage from 'components/page/sidebar-page/SidebarPage';
import SideNavigation from 'components/side-navigation-v2/SideNavigation';
import SettingsSidebar from 'modules/settings/SettingsSidebar';

import { __t, applyTranslations } from 'utils/language';
import {
  getInfluencersAgencySettingsSubnavigation,
  mapNavigationNavItemToSideNavigationItem
} from 'utils/navigation';

applyTranslations(require('../influencers-agencies-pages.i18n.json'));

import { InfluencersAgency, Organization } from 'types';

type OwnProps = {
  agencyId: number,
  documentTitle: string,
  children: React.ReactNode
}

type StateProps = {
  isAdminMode: boolean,
  organizations: {
    [x: number]: Organization
  },
  agency: InfluencersAgency
}

type Props = OwnProps & StateProps;

const BaseInfluencerAgencyPage = ({
  agencyId,
  documentTitle,
  isAdminMode,
  organizations,
  agency,
  children
}: Props) => {
  const getSidebar = () => {
    const isAccountPartOfOrg = Boolean(organizations[agency.organizationId]);

    if (agencyId) {
      return (
        <SideNavigation
          items={[
            {
              type: 'container',
              title: __t('influencers_agencies_pages.sidebar_title'),
              children: getInfluencersAgencySettingsSubnavigation(agencyId, isAdminMode, isAccountPartOfOrg)
                .map(mapNavigationNavItemToSideNavigationItem)
            }
          ]}
        />
      );
    }

    return <SettingsSidebar />;
  };

  return (
    <Page
      documentTitle={(isAdminMode ? `${__t('influencers_agencies_pages.admin')} - ` : '') + documentTitle}
      subnavigationClassName="page__agency-subnavigation"
    >
      <SidebarPage
        sidebarWidth="narrow"
        scrollable={!isAdminMode}
        sidebarContent={getSidebar()}
      >
        {children}
      </SidebarPage>
    </Page>
  );
};

const mapStateToProps = ({ router, organizations, influencersAgency }): StateProps => ({
  organizations: organizations.mapByOrganizationId,
  agency: influencersAgency.profile,
  isAdminMode: /^\/admin\//.test(router.location.pathname)
});

export default connect(mapStateToProps)(BaseInfluencerAgencyPage);
